

export const database = {
    users :{
        talakar:{
            id:'8c30a6da-c8e0-484b-8f23-c38c0fc485a9',
        }
    }
}